import {
  HeadingProps as CHeadingProps,
  Heading as ChakraHeading,
} from '@chakra-ui/react';
import useTranslate from '~/common/utils/translate';
import React from 'react';

type HeadingProps = CHeadingProps & { params?: string[] };

export const Heading: React.FC<HeadingProps> = ({
  params,
  children,
  ...props
}) => {
  const translate = useTranslate();
  return (
    <ChakraHeading {...props}>{translate(children, params)}</ChakraHeading>
  );
};
